import { Controller } from "@hotwired/stimulus"
import { formValidation, plugins } from "formvalidation"
import Bootstrap3 from "formvalidation/plugins/Bootstrap3"

export default class extends Controller {
  static targets = [
    "form",
    "submitButton",
    "instanceIdField",
    "instanceIdLabel",
    "apiKeyField",
    "apiKeyLabel",
  ]

  connect() {
    this.setupFormValidation()

    this.instanceIdFieldTarget.addEventListener("input", this.validateField.bind(this, "instanceId"))
    this.apiKeyFieldTarget.addEventListener("input", this.validateField.bind(this, "apiKey"))
  }

  setupFormValidation() {
    this.fv = formValidation(
      this.formTarget,
      {
        plugins: {
          bootstrap3: new Bootstrap3(),
          trigger: new plugins.Trigger({
            event: "blur"
          })
        },
        fields: {
          instanceId: {
            selector: '[name="integrations_service_now[instance_id]"]',
            validators: {
              notEmpty: { message: "Instance ID is required." },
            }
          },
          apiKey: {
            selector: '[name="integrations_service_now[api_key]"]',
            validators: {
              notEmpty: { message: "API Key is required." },
            }
          },
        }
      }
    )

    this.fv.on("core.field.invalid", (field) => this.toggleLabel(field, true))
    this.fv.on("core.field.valid", (field) => this.toggleLabel(field, false))
  }

  validateField(field) {
    // Trigger the validate so the `core.field.valid/invalid`
    // callback can run and update the label color
    this.fv.validateField(field)
    this.toggleButtonDisable()
  }

  toggleLabel(field, invalid) {
    // Same red used by `formValidation`
    this[`${field}LabelTarget`].style.color = invalid ? "#E74C3C" : null
  }

  toggleButtonDisable() {
    // Not running this.fv.validate here to prevent the
    // form fields from all being validated and turning red
    const allFilledOut = (
      this.instanceIdFieldTarget.value.length > 0 &&
      this.apiKeyFieldTarget.value.length > 0
    )

    this.submitButtonTarget.disabled = !allFilledOut
  }
}
